// Generated by BUCKLESCRIPT VERSION 3.1.5, PLEASE EDIT WITH CARE
'use strict';

var ReasonReact = require("reason-react/src/ReasonReact.js");
var ReactHelmet = require("react-helmet");
var Js_null_undefined = require("bs-platform/lib/js/js_null_undefined.js");

function make(title, titleTemplate, defaultTitle, meta, children) {
  return ReasonReact.wrapJsForReason(ReactHelmet.default, {
              title: Js_null_undefined.fromOption(title),
              titleTemplate: Js_null_undefined.fromOption(titleTemplate),
              defaultTitle: Js_null_undefined.fromOption(defaultTitle),
              meta: Js_null_undefined.fromOption(meta)
            }, children);
}

exports.make = make;
/* ReasonReact Not a pure module */



// WEBPACK FOOTER //
// ./src/bindings/gatsby/helmet.js